import cx from 'classnames'
import React, { ReactNode } from 'react'

import ProductCardLink from '@/components/Product/ProductCardLink'
import '@/components/Product/Products/Products.scss'
import { getProducts } from '@/serverActions/getProducts'
import { ProductType } from '@/types/product'

type Props = {
  nextLink?: boolean
  productIds?: string[] | null
  groupSymbol?: string | null
  children: (_: ProductType) => ReactNode
}
export default async function Products({ nextLink = true, groupSymbol = null, productIds = null, children }: Props) {
  const allProducts = await getProducts({ groupSymbol })
  const products =
    productIds != null ? allProducts.filter((product) => productIds.includes(product.productId)) : allProducts

  if (products.length === 0) {
    return <></>
  }

  return (
    <div className="l-product-products">
      {products.map((product) => {
        return (
          <div className={cx('l-product-products__item')} key={product.productId}>
            <ProductCardLink nextLink={nextLink} product={product}>
              {children(product)}
            </ProductCardLink>
          </div>
        )
      })}
    </div>
  )
}
